export function getPortalBaseUrl() {
  return process.env.VUE_APP_ENV === 'production'
    ? 'https://portal.vibrant-wellness.com'
    : 'https://staging.va-portal.pages.dev'
}

/**
 * Patient-profile link on the current origin.
 *
 * va-portal and this app share a host, so the link stays where the user
 * already is instead of jumping to the mapped portal host. Only `origin` is
 * used: this app runs in history mode, so `pathname` is the current route
 * rather than a base path and must not be carried over.
 */
export function getPatientProfileUrl({ patientId, accessionId, sampleId }) {
  return `${window.location.origin}/#/patient-profile/${patientId}/${accessionId}/${sampleId}`;
}
